export default "__VITE_ASSET__z8gmBg_h__"